import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import DataTable from "react-data-table-component";
import axios from "axios";
import { customTableStyles } from "../../assets/CustomTableStyles";
import { del, post, get } from "../../services/api";

const FacilityDropdownValue = ({ dropdownName, isReadOnly }) => {
  const [dropdownValues, setDropdownValues] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
 const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm();

  // Fetch values on mount or when dropdownName changes
  useEffect(() => {
    if (dropdownName) {
      fetchValuesByName(dropdownName);
    }
  }, [dropdownName]);

  const fetchValuesByName = async (name) => {
    try {
      const res = await get(`Facility/dropdowns/${name}`);
      console.log(`${name}`, res)
      setDropdownValues(res);
    } catch (err) {
      console.error("Error fetching dropdown values:", err);
    }
  };

  const saveData = async (data) => {
    const payload = {
      dropdownName,
      name: data.value,
    };

    try {
      if (isEditMode && editId !== null) {
        // Update
        await post("Facility/update-value", {
          ...payload,
          id: editId,
        });
      } else {
        // Add
        await post("Facility/save-value", payload);
      }

      await fetchValuesByName(dropdownName);
      setValue("value", "");
      setEditId(null);
      setIsEditMode(false);
    } catch (err) {
      console.error("Error saving data:", err);
    }
  };

  const handleEditClick = (item) => {
    setValue("value", item.value);
    setEditId(item.id);
    setIsEditMode(true);
  };

  const handleDeleteClick = async (id) => {
    try {
      await del(`Facility/delete-value/${id}?dropdownName=${dropdownName}`);
      fetchValuesByName(dropdownName);
    } catch (err) {
      console.error("Error deleting item:", err);
    }
  };

   const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      // width: "60px",
    },

    {
      name: "Value",
      selector: (row) => row.value,
      sortable: true,
      // width: "100px",
    },
    // {
    //   name: "Key",
    //   selector: (row) => row.key,
    //   sortable: true,
    //   // width: "250px",
    // },
    {
      name: "Action",
      // width: "60px",
      selector: (row) => (
        <div>
          <button
            type="button"
            className="btn p-0"
            onClick={() => handleEditClick(row)}
          >
            <i className="fas fa-pencil"></i>
          </button>
        </div>
      ),
    },
  ];
  return (
    <div className="">
      <div className="row g-3">
        <div className="col-md-4">
          <div className="card h-100">
            <div className="card-body">
              <form className="row g-3" onSubmit={handleSubmit(saveData)}>
                <div className="col-md-12">
                  <label className="form-label">
                    Value <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("value", {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                  />
                  {errors.value && (
                    <small className="text-danger">
                      {errors.value.message}
                    </small>
                  )}
                </div>
                <div className="col-12 mt-3">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm"
                    disabled={isSubmitting}
                  >
                    {isEditMode ? "Update" : "Save"}
                  </button>
                  {isEditMode && (
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm ms-2"
                      onClick={() => {
                        setEditId(null);
                        setIsEditMode(false);
                        setValue("value", "");
                      }}
                    >
                      Cancel
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-md-8">
          <div className="card h-100">
            <div className="card-body">
              <DataTable
                columns={columns}
                data={dropdownValues ? dropdownValues : []}
                pagination
                dense
                customStyles={customTableStyles}
                highlightOnHover
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacilityDropdownValue;
